import { InitialValues } from "./types";
import {
  HAS_COMPANY_ADDRESS_FIELD,
  HAS_COMPANY_NAME_FIELD,
  HAS_PHONE_FIELD,
  HAS_REPORTS_TO_FIELD,
  HAS_STANDS_WORKINGON_FIELD
} from "../constants";
import { CustomerTypes } from "../enums/CustomerTypes";
import { IProduct } from "../../../common/types";
import googleLibPhoneNumber from "google-libphonenumber";
import { PhoneInputValue } from "../form/components/types";
import { ProductTypeName } from "../form/CreateBadgeForm.enums";

export const initialValues: InitialValues = {
  personInfo: {
    customerType: "",
    badgeType: "",
    firstName: "",
    lastName: "",
    email: "",
    jobTitle: "",
    mobilePhone: { countryCode: "", phone: "" },
    userAccess: "",
    reportsTo: ""
  },
  orgInfo: {
    companyName: "",
    location: "",
    address: "",
    city: "",
    country: "",
    state: "",
    province: "",
    postcode: "",
    standsWorkingOn: ""
  },
  id: ""
};

export const hasMobilePhoneField = (customerType?: string) =>
  customerType && HAS_PHONE_FIELD ? customerType !== HAS_PHONE_FIELD[0] && customerType !== HAS_PHONE_FIELD[1] : false;

export const hasOnsiteMobileNumberField = (customerType?: string) =>
  customerType ? Boolean(HAS_PHONE_FIELD.find(type => customerType === type)) : false;

export const hasReportsToField = (customerType?: string) =>
  customerType ? Boolean(HAS_REPORTS_TO_FIELD.find(type => customerType === type)) : false;

export const hasStandsWorkingOnField = (customerType?: string) =>
  customerType ? Boolean(HAS_STANDS_WORKINGON_FIELD.find(type => customerType === type)) : false;

export const hasCompanyNameField = (customerType?: string) =>
  customerType ? Boolean(HAS_COMPANY_NAME_FIELD.find(type => customerType === type)) : false;

export const hasCompanyAddressField = (customerType?: string) =>
  customerType ? Boolean(HAS_COMPANY_ADDRESS_FIELD.find(type => customerType === type)) : false;

export const hasUserAccessField = (customerType?: string) => customerType === CustomerTypes.STAFF;

export const isProductWithTax = (product: IProduct) => {
  if (product.__typename === ProductTypeName.GROUPED_PRODUCT) {
    return Boolean(product.items[0]?.product?.price?.regularPrice?.adjustments[0]?.code);
  }
  return Boolean(product.price?.regularPrice?.adjustments[0]?.code);
};

export const getSplitMobilePhone = (phone: string) => {
  try {
    const phoneNumberUtil = googleLibPhoneNumber.PhoneNumberUtil.getInstance();
    const trimmedValue = phone.trim();
    const number = phoneNumberUtil.parseAndKeepRawInput(trimmedValue);
    return { countryCode: `+${number.getCountryCode()}`, phone: `${number.getNationalNumber()}` };
  } catch (e) {
    return { countryCode: "", phone: "" };
  }
};

export const phoneNumberToString = (mobilePhone: PhoneInputValue) => (mobilePhone ? `${mobilePhone.countryCode}${mobilePhone.phone}` : "");
